import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import './i18n';
import { BrowserRouter } from "react-router-dom";
import AuthProvider from 'contexts/auth-context';


ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <IconSettings iconPath="/assets/icons">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </IconSettings>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
